<script lang="ts">
    
    import { Icon, Label } from "sveltestrap";

    export let required = false;
    export let invalid = false;

</script>

<Label>
    <span class:fw-bold={required} class:text-danger={invalid}>
        <slot />
        {#if required}
            <small><Icon name="asterisk" /></small>
        {/if}
    </span>
</Label>
